module.exports = __webpack_public_path__ + "static/media/Abra_gaussian2.64989b89.png";